import { render, staticRenderFns } from "./DisputeLetterAddButton.vue?vue&type=template&id=9b7c46c8&"
import script from "./DisputeLetterAddButton.vue?vue&type=script&lang=js&"
export * from "./DisputeLetterAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports